import React, { useState } from 'react';
import { CheckCircle2Icon, MailIcon } from 'lucide-react';
import { LogoMark } from '../components/LogoMark';
export function FieldNotes() {
  const [submitted, setSubmitted] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // eslint-disable-next-line no-console
    console.log('field_notes_signup', {
      source: 'community_block'
    });
    setSubmitted(true);
  };
  return <section className="w-full bg-charcoal py-20 lg:py-24" data-id="element-514">
      <div className="relative mx-auto max-w-4xl px-5 text-center lg:px-8" data-id="element-515">
        <div className="mgs-traces absolute inset-0 opacity-20" aria-hidden data-id="element-516" />
        <div className="relative" data-id="element-517">
          <LogoMark className="mx-auto h-7 w-7" title="Mine Geology Systems" data-id="element-518" />
          <h2 className="mt-5 text-3xl font-black leading-tight text-cream sm:text-4xl" data-id="element-519">
            Join geologists thinking differently about mine geology systems.
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-base leading-relaxed text-cream/80" data-id="element-520">
            Field Notes is practical, occasional and useful — new resources,
            case studies and framework thinking, sent only when there's
            something worth reading.
          </p>

          {submitted ? <div className="mx-auto mt-8 inline-flex items-center gap-2 rounded-md bg-improvements/20 px-5 py-3 text-sm font-medium text-cream" data-id="element-521">
              <CheckCircle2Icon className="h-5 w-5 text-improvements" data-id="element-522" />
              You're on the list. Welcome to Field Notes.
            </div> : <form onSubmit={handleSubmit} className="mx-auto mt-8 flex max-w-md flex-col gap-3 sm:flex-row" data-id="element-523">
              <label htmlFor="fn-email" className="sr-only" data-id="element-524">
                Email address
              </label>
              <div className="relative flex-1" data-id="element-525">
                <MailIcon className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-warmgray" data-id="element-526" />
                <input id="fn-email" type="email" required placeholder="you@example.com" className="w-full rounded-md border border-cream/20 bg-cream py-3 pl-9 pr-3 text-sm text-charcoal placeholder:text-warmgray/60" data-id="element-527" />
              </div>
              <button type="submit" className="rounded-md bg-yellow px-5 py-3 text-sm font-bold text-charcoal hover:brightness-95" data-id="element-528">
                Join Field Notes
              </button>
            </form>}
          <p className="mt-4 text-xs text-cream/60" data-id="element-529">
            No spam. Practical field notes only.
          </p>
        </div>
      </div>
    </section>;
}